import React, {useState} from "react";
import {changePassword} from "../authRequests";
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  InputGroup,
  InputRightElement,
  Button,
  Text,
} from "@chakra-ui/react";

export default function ChangePassword({dashState}) {
  const {patient, relationship} = dashState;
  const [cp, setCp] = useState("");
  const [np, setNp] = useState("");
  const [cnp, setCnp] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [showCp, setShowCp] = useState(false);
  const [showNp, setShowNp] = useState(false);
  const [showCnp, setShowCnp] = useState(false);

  return (
    <Box
      as="form"
      onSubmit={(e) => {
        e.preventDefault();

        if (np === cnp && (np?.length || 0) >= 8) {
          setLoading(true);
          changePassword(dashState, {
            userId:
              dashState?.userType === "patient"
                ? patient?.pid
                : relationship?.rid,
            currentPassword: cp,
            newPassword: np,
            db: dashState.db,
          })
            .then((res) => {
              setLoading(false);
              setStatus("Successful update!");
              setCp("");
              setNp("");
              setCnp("");
            })
            .catch((err) => {
              setStatus(err.response.data);
              console.log(err);
              setLoading(false);
            });
        }
      }}
    >
      <FormControl mb={3} isRequired>
        <FormLabel fontSize="sm" color="gray.700" mb={1}>Current password</FormLabel>
        <InputGroup size="sm">
          <Input
            type={showCp ? "text" : "password"}
            autoComplete="off"
            value={cp}
            borderColor="gray.200"
            _hover={{borderColor: "gray.300"}}
            _focus={{borderColor: "#5754FF", boxShadow: "0 0 0 1px #5754FF"}}
            onChange={(e) => {
              setStatus("");
              setCp(e.target.value);
            }}
          />
          <InputRightElement width="3rem">
            <Button
              size="xs"
              variant="ghost"
              color="gray.500"
              fontWeight="normal"
              onClick={() => setShowCp((v) => !v)}
            >
              {showCp ? "Hide" : "Show"}
            </Button>
          </InputRightElement>
        </InputGroup>
        {status && (
          <Text
            fontSize="xs"
            mt={1}
            color={status.includes("update") ? "green.500" : "red.500"}
          >
            {status}
          </Text>
        )}
      </FormControl>

      <FormControl mb={3} isRequired>
        <FormLabel fontSize="sm" color="gray.700" mb={1}>New password</FormLabel>
        <InputGroup size="sm">
          <Input
            type={showNp ? "text" : "password"}
            autoComplete="off"
            value={np}
            borderColor="gray.200"
            _hover={{borderColor: "gray.300"}}
            _focus={{borderColor: "#5754FF", boxShadow: "0 0 0 1px #5754FF"}}
            onChange={(e) => {
              setStatus("");
              setNp(e.target.value);
            }}
          />
          <InputRightElement width="3rem">
            <Button
              size="xs"
              variant="ghost"
              color="gray.500"
              fontWeight="normal"
              onClick={() => setShowNp((v) => !v)}
            >
              {showNp ? "Hide" : "Show"}
            </Button>
          </InputRightElement>
        </InputGroup>
        {!!np && np.length < 8 && (
          <Text fontSize="xs" mt={1} color="red.500">
            Password must be at least 8 characters
          </Text>
        )}
      </FormControl>

      <FormControl mb={4} isRequired>
        <FormLabel fontSize="sm" color="gray.700" mb={1}>Confirm new password</FormLabel>
        <InputGroup size="sm">
          <Input
            type={showCnp ? "text" : "password"}
            autoComplete="off"
            value={cnp}
            borderColor="gray.200"
            _hover={{borderColor: "gray.300"}}
            _focus={{borderColor: "#5754FF", boxShadow: "0 0 0 1px #5754FF"}}
            onChange={(e) => {
              setStatus("");
              setCnp(e.target.value);
            }}
          />
          <InputRightElement width="3rem">
            <Button
              size="xs"
              variant="ghost"
              color="gray.500"
              fontWeight="normal"
              onClick={() => setShowCnp((v) => !v)}
            >
              {showCnp ? "Hide" : "Show"}
            </Button>
          </InputRightElement>
        </InputGroup>
        {!!np && !!cnp && np !== cnp && (
          <Text fontSize="xs" mt={1} color="red.500">
            Passwords do not match
          </Text>
        )}
      </FormControl>

      <Button
        type="submit"
        isLoading={loading}
        isDisabled={np !== cnp || (np?.length || 0) < 8 || !cp || loading}
        bg="#5754FF"
        color="white"
        size="sm"
        fontWeight="500"
        _hover={{bg: "#4644e0"}}
        _active={{bg: "#3a38c8"}}
        _disabled={{bg: "gray.200", color: "gray.400", cursor: "not-allowed"}}
      >
        Update password
      </Button>
    </Box>
  );
}
